package org.teddapp.project.auth

import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import org.teddapp.project.crypto.Pbkdf2

/**
 * Navigateur : PBKDF2-HMAC-SHA256 en Kotlin pur. L'interface est synchrone, et la
 * dérivation du navigateur (WebCrypto) ne l'est pas.
 */
@OptIn(ExperimentalEncodingApi::class)
actual object PasswordHasher {
    private const val ITERATIONS = 100_000

    actual fun randomSalt(): String {
        val bytes = ByteArray(16)
        val random = js("new Uint8Array(16)")
        js("crypto").getRandomValues(random)
        for (i in bytes.indices) bytes[i] = random[i].unsafeCast<Int>().toByte()
        return Base64.encode(bytes)
    }

    actual fun hash(password: String, salt: String): String =
        Base64.encode(Pbkdf2.derive(password.encodeToByteArray(), Base64.decode(salt), ITERATIONS))

    actual fun verify(password: String, salt: String, expectedHash: String): Boolean {
        val actual = hash(password, salt)
        // Comparaison en temps constant : on parcourt tout, même après une différence.
        var diff = actual.length xor expectedHash.length
        for (i in 0 until minOf(actual.length, expectedHash.length)) diff = diff or (actual[i].code xor expectedHash[i].code)
        return diff == 0
    }
}
